interface Position {
  readonly latitude: number;
  readonly longitude: number;
}

const GEO_TIMEOUT_MS = 8000;

export default function getPosition(): Promise<Position | null> {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve(null);
      return;
    }

    const timer = setTimeout(() => resolve(null), GEO_TIMEOUT_MS);

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        clearTimeout(timer);
        resolve(coords);
      },
      () => {
        clearTimeout(timer);
        resolve(null);
      },
      { timeout: GEO_TIMEOUT_MS, enableHighAccuracy: false }
    );
  });
}
